import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  testCard: {
    borderRadius: '11.3px',
    border: 'solid 1.4px #eeeeee',
    backgroundColor: '#f6f6f6',
    width: '70%',
    height: '195px',
    marginLeft: '30px'
  }
});
export default useStyles;
